@let status = this.status();
@if (status) {
    <div class="status-chip status-chip--{{ color() }}">
        <p>
            {{ label() | titlecase }}
        </p>
    </div>
}
